<app-loader></app-loader>
<div class="container" #scrollContainer>
  <div class="block-1" [ngClass]="{ 'chat-main-block': surveyBlock || notesBlock }">
    <app-toaster-messages></app-toaster-messages>
    <div class="chat-sub-block">
      <div
        [ngClass]="{ 'chat-window-block': surveyBlock || notesBlock, 'chat-main-block-servey': !surveyBlock && !notesBlock }">
        <div class="chat-header">
          <div class="left-header-block">
            <img class="chatbotheadericon" [src]="chatbotheadericon" alt="Chat Icon" />
            <div class="header-title-block">
              <div class="header-title">{{ headerTitleText }} {{ userName }}!</div>
              <div class="header-sub-text">{{ headerSubtitleText }}</div>
            </div>
          </div>

          <div class="right-header-block servery-icons">
            <div class="right-icons">
              <!-- <div>
                <img tooltip="Daily" class="right-icon" [ngClass]="{ selected: issueFrequency === 'd' }"
                  [src]="dailySurveyMenuIcon" alt="Daily" (click)="getIssues('d')" />
                <div class="no-underlined"
                  [ngClass]="{ underline: issueFrequency === 'd', 'no-underlined': issueFrequency !== 'd' }"></div>
              </div> -->
              <div (click)="confirmLogout = true;" class="action-point logout-btn">
                <img class="default-icon" [src]="logoutDisplayIcon" alt="Logout Icon" />
                <img class="hover-icon" [src]="logoutIconHover" alt="Logout Icon" />
                Logout
              </div>
            </div>
          </div>
        </div>

        <div appDynamicHeight="chat-body" class="chat-body" #endOfChat>
          <app-issuelistsr></app-issuelistsr>
        </div>


      </div>
    </div>
  </div>

  <div class="chat-survey-block note-block block-2" *ngIf="notesBlock">
    <app-notes (noteBlockEvent)="closeNotes($event)" [notesData]="notesBlockData"></app-notes>
  </div>
</div>
<p-dialog header="Are you sure!" [modal]="true" [(visible)]="confirmLogout" class="logout-confirmation"
  [style]="{ width: '25rem' }">
  <span class="p-text-secondary block mb-8">You want to logout?</span>
  <div class="btn-container">
    <p-button label="Cancel" severity="secondary" (click)="confirmLogout = false;" />
    <p-button label="Logout" severity="warn" (click)="confirmLogout = false; logout()" />
  </div>
</p-dialog>